import { render, staticRenderFns } from "./updateSupportPackage.vue?vue&type=template&id=3536f379"
import script from "./updateSupportPackage.vue?vue&type=script&lang=js"
export * from "./updateSupportPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports